
import { httpPut, httpGetNoAuth } from '../../../../Util/http';
import { addAlert } from '../../../../MsgNotify/msgNotifyActions';


export const DAILY_REPORT_UPDATE_REMARK = 'DAILY_REPORT_UPDATE_REMARK'
export const dailyReportUpdateRemark = (value, typeOf = "remark") => (
  {
    type: DAILY_REPORT_UPDATE_REMARK,
    typeOf,
    value
  }
)



export function attemptSaveRemark(currentDailyReportId, getState, dispatch) {
  var _url = process.env.REACT_APP_webApiEndPoint + 'api/dailyreport/remark/register'
  let remark = getState().dailyReportRemarkReducer.remark;
  let englishRemark = getState().dailyReportRemarkReducer.englishRemark;
  remark = englishRemark ? remark + "&:TRANSLATED:&" + englishRemark : remark;
  return httpPut(_url, { id: currentDailyReportId, remark: remark })
    .catch(() => {
      dispatch(addAlert("Kunne ikke gemme bemærkning"))
      throw new Error("Kunne ikke gemme bemærkning")
    })
}


export const TRANSLATE_REMARK_TEXT_REQUEST = 'TRANSLATE_REMARK_TEXT_REQUEST'
export const tranlateTextRequest = () => (
  {
    type: TRANSLATE_REMARK_TEXT_REQUEST
  }
)

export const TRANSLATE_REMARK_TEXT_SUCCESS = 'TRANSLATE_REMARK_TEXT_SUCCESS'
export const tranlateTextSuccess = (value) => (
  {
    type: TRANSLATE_REMARK_TEXT_SUCCESS,
    value
  }
)

export const TRANSLATE_REMARK_TEXT_FAILURE = 'TRANSLATE_REMARK_TEXT_FAILURE'
export const tranlateTextFailure = () => (
  {
    type: TRANSLATE_REMARK_TEXT_FAILURE
  }
)


export function attemptTranslateText() {
  return (dispatch, getState) => {
    let remark = getState().dailyReportRemarkReducer.remark;
    let _url = 'https://www.googleapis.com/language/translate/v2?key=AIzaSyBWsPmR2OIE3WNLqkrl0_vJjkrG6emp--c&source=da&target=en&format=text'
    let resultsplit = remark.split("&").join("og").split(/\r?\n/);
    resultsplit.forEach((line) => {
      _url += '&q=' + line
    })
    return httpGetNoAuth(_url)
      .then((response) => {
        return response.json()
      })
      .then((result) => {
        //if concat the results
        let concatRes = "";
        result.data.translations.forEach((line, index) => {
          concatRes += line.translatedText;
          if (index !== result.data.translations.length - 1) {
            concatRes += "\n"
          }
        })
        dispatch(tranlateTextSuccess(concatRes));
      })
      .catch(() => {
        dispatch(addAlert("Kunne ikke gemme beskrivelsen"))
        throw new Error("Kunne ikke gemme beskrivelsen")
      })
  };
}





// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/DailyReport/Remark/actions.js